module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-backplates.b6474f36.png";